// extracted by mini-css-extract-plugin
module.exports = {"blog-bg":"style_blog-bg__k8Gcg"};